import { render, staticRenderFns } from "./SwitchDarkMode.vue?vue&type=template&id=61573cc7&"
import script from "./SwitchDarkMode.vue?vue&type=script&lang=js&"
export * from "./SwitchDarkMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports